module.exports = function() {
  return new Worker(__webpack_public_path__ + "e4d0eb5c3c6e0dfcbfd4.worker.js");
};